module.exports = __webpack_public_path__ + "static/media/drivewell.3f3039d2.png";